import * as React from 'react';

import styled, { tstyled } from '../../theme';
import SelectorArrow from '../../assets/selector-arrow-right.svg';
import { IRenderProps } from '../../models/ProjectType';
import { Link } from 'react-router-dom';

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -52.5%);
  text-align: center;
  user-select: none;
`;

const LinkContainer = styled.div`
  display: block;
  cursor: pointer;
  margin-bottom: 30vmin;

  @media (min-width: 768px) {
    margin-bottom: 7vmin;
  }

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: #efd5a1;
    text-decoration: none;
    letter-spacing: -0.8vw;
    font-size: 9.5vw;
  }
`;

const ArrowContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  transition: 0.3s cubic-bezier(0.86, 0, 0.07, 1) transform;
  will-change: transform;
  display: none;
  height: 0;

  @media (min-width: 768px) {
    display: block;
  }
`;

const Arrow = tstyled<{ position: 'left' | 'right' }, HTMLImageElement>(
  styled.img
)`
  position: absolute;
  width: 9.5vw;
  top: 0;

  ${props =>
    props.position === 'right' && 'right: -3vw; transform: rotate(180deg)'}


  ${props => props.position === 'left' && 'left: -3vw'}
`;

const slugOrderMap = {
  curatorial: 0,
  commission: 1,
  personal: 2,
};

export default class ProjectTypeSelection extends React.PureComponent<
  IRenderProps
> {
  state = {
    arrowOffset: 0,
    hoveredIndex: 0,
  };

  private links: HTMLDivElement[] = [];

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.adjustArrowsByHoveredIndex();
  };

  adjustArrowsByHoveredIndex = () => {
    const { hoveredIndex } = this.state;
    this.setState({
      arrowOffset: this.links[hoveredIndex].offsetTop,
    });
  };

  handleMouseEnter = (index: number) => (event: any) => {
    this.setState({
      arrowOffset: event.target.offsetTop,
      hoveredIndex: index,
    });
  };

  render() {
    const { data } = this.props;
    return (
      <Container>
        <ArrowContainer
          style={{
            transform: `translateY(${this.state.arrowOffset}px)`,
          }}
        >
          <Arrow position="left" src={SelectorArrow} />
          <Arrow position="right" src={SelectorArrow} />
        </ArrowContainer>
        {data.items
          .sort((a, b) => {
            return slugOrderMap[a.fields.slug] - slugOrderMap[b.fields.slug];
          })
          .map((item, index) => (
            <LinkContainer
              key={item.fields.slug}
              innerRef={ref => {
                this.links[index] = ref!;
              }}
            >
              <Link
                onMouseEnter={this.handleMouseEnter(index)}
                to={`/project/${item.fields.slug}`}
              >
                {item.fields.name}
                Projects
              </Link>
            </LinkContainer>
          ))}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Home/ProjectTypeSelectorDesktop.tsx